module.exports = __webpack_public_path__ + "static/media/Skin_tone_9.997d9fbb.svg";